import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ReactVimeoOriginal from '@u-wave/react-vimeo';
import useIsBrowser from 'hooks/useIsBrowser';
import * as Sentry from '@sentry/react';
import isNewConsumerApp from 'commons/isNewConsumerApp';
const Boundary = !isNewConsumerApp ? Sentry?.ErrorBoundary : React.Suspense;

// There is a known intermittent error in the react-vimeo package (https://github.com/u-wave/react-vimeo/issues/244)
// The root cause of this error appears to be within the Vimeo player itself (https://github.com/vimeo/player.js/issues/688)
// Until the root cause is fixed in the Vimeo player, we use this custom
// component to catch the error and ignore it if it occurs.

const ReactVimeo = props => {
  const $ = _c(2);
  const isBrowser = useIsBrowser();
  if (isBrowser) {
    let t0;
    if ($[0] !== props) {
      t0 = <Boundary fallback={null}><ReactVimeoOriginal {...props} /></Boundary>;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  return null;
};
export default ReactVimeo;